import React, { Component } from 'react'
import Review from '../Components/Review/EditReview'
import Program from '../Components/Program/WrappedProgram'
import ToggleDisplay from 'react-toggle-display'
import update from 'react-addons-update'
import _sortBy from 'lodash/sortBy'
import {browserHistory} from 'react-router'

class Edit extends Component {

  constructor (props) {
    super(props)
    const views = ['program', 'review']
    this.state = {
      views,
      currentView: views[0],
      earningRuleId: props.earning_rule.id,
      spendingAmount: props.earning_rule.amount,
      pointFromSpendingAmount: props.earning_rule.point,
      newMemberPoint: props.new_member_point,
      rewards: this._toDisplayRewards(props.rewards),
      sentValidationCode: props.is_sent_validation_code
    }
  }

  componentDidMount () {
    this.removeBrowserListener = browserHistory.listenBefore(location => {
      if (this._isDirty() && !this.props.nextAction) {
        this.props.askConfirmAction(location)
        return false
      }
    })
  }

  componentWillUnmount () {
    this.removeBrowserListener()
  }

  render () {
    const { currentView, views, ...editState } = this.state
    return (
      <div style={{height: '100%'}}>
        <ToggleDisplay show={currentView === views[0]}>
          <Program
            title='Edit Loyalty Program'
            isAccordionEnabled
            {...editState}
            setSpendingAmount={this._setSpendingAmount}
            setPointFromSpendingAmount={this._setPointFromSpendingAmount}
            setNewMemberPoint={this._setNewMemberPoint}
            addReward={this._addReward}
            removeReward={this._removeReward}
            toggleSentValidationCode={this._toggleSentValidationCode}
            sentValidationCode={this.state.sentValidationCode}
            showReview={this._showReview}
            cancelProgram={this.props.cancelProgram}
          />
        </ToggleDisplay>
        <ToggleDisplay show={currentView === views[1]}>
          <Review
            {...editState}
            revise={this._showCreateProgram}
            confirmProgram={this._confirmProgram}
          />
        </ToggleDisplay>
      </div>
    )
  }

  _isDirty = () => {
    let {spendingAmount, pointFromSpendingAmount, newMemberPoint, rewards, sentValidationCode} = this.state
    return spendingAmount !== this.props.earning_rule.amount || pointFromSpendingAmount !== this.props.earning_rule.point ||
      newMemberPoint !== this.props.new_member_point || sentValidationCode !== this.props.is_sent_validation_code ||
      JSON.stringify(rewards) !== JSON.stringify(this._toDisplayRewards(this.props.rewards))
  }

  _toDisplayRewards = (rewards) => {
    rewards = rewards.map((reward) => {
      return {
        id: reward.reward_id,
        point: reward.redeem_point,
        discount: reward.discount,
        discountType: reward.discount_type,
        maximumDiscount: reward.max_discount_amount,
        minimumPurchase: reward.min_purchase_amount
      }
    })

    return _sortBy(rewards, ['point'])
  }

  _setSpendingAmount = (spendingAmount) => {
    this.setState({spendingAmount})
  }

  _setPointFromSpendingAmount = (pointFromSpendingAmount) => {
    this.setState({pointFromSpendingAmount})
  }

  _setNewMemberPoint = (newMemberPoint) => {
    this.setState({newMemberPoint})
  }

  _addReward = (newReward) => {
    this.setState({rewards: this.state.rewards.concat(newReward)})
  }

  _removeReward = (index) => {
    this.setState({
      rewards: update(this.state.rewards, {[index]: {deleted: {$set: true}}})
    })
  }

  _toggleSentValidationCode = () => {
    this.setState({ sentValidationCode: !this.state.sentValidationCode })
  }

  _confirmProgram = () => {
    let rewards = this.state.rewards.map((reward) => {
      let rewardReq = {
        'reward_id': reward.id || null,
        'reward_type': 'TOTAL_SALES',
        'redeem_point': reward.point,
        'discount': reward.discount,
        'is_deleted': reward.deleted
      }

      if (reward.discountType === 'AMOUNT') {
        rewardReq.discount_type = 'AMOUNT'
        rewardReq.min_purchase_amount = reward.minimumPurchase
      } else if (reward.discountType === 'PERCENTAGE') {
        rewardReq.max_discount_amount = reward.maximumDiscount
        rewardReq.discount_type = 'PERCENTAGE'
      }
      return rewardReq
    })

    let newMemberPoint = this.state.newMemberPoint === '' ? 0 : this.state.newMemberPoint
    let data = {
      'earning_rule': {
        'id': this.state.earningRuleId,
        'type': 'SPENDING',
        'amount': this.state.spendingAmount,
        'point': this.state.pointFromSpendingAmount
      },
      'new_member_point': newMemberPoint,
      'description': '',
      'is_sent_validation_code': this.state.sentValidationCode,
      'rewards': rewards
    }
    this.props.editLoyalty(data)
  }

  _showCreateProgram = () => {
    this.setState({
      currentView: this.state.views[0]
    })
  }

  _showReview = () => {
    this.setState({
      currentView: this.state.views[1]
    })
  }
}

export default Edit



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Edit/Edit.js